window.onload = function (event) {
    
    const player = {
        element: document.getElementById("Slider-Thumbnails-template--18577101652203__main").querySelectorAll(":scope > li"),
        topPosition: 0,
        leftPosition: 0,
        step: 90,
        move: function (direction) {
            // console.log(direction);
            switch (direction) {
                case "ArrowUp":
                    // console.log(this.topPosition);
                    if (this.topPosition < 0) {
                        this.topPosition = this.topPosition + this.step;
                        this.element.forEach((item) => (item.style.top = this.topPosition + "px"));
                        // this.element.forEach((item) => (item.style.top = "0px"));
                    } else {
                        // this.topPosition = this.topPosition + this.step;
                        // this.element.forEach((item) => (item.style.top = this.topPosition + "px"));
                    }
                    // console.log(this.topPosition);
                    break;
                case "ArrowDown":
                    // console.log(this.topPosition);
                    if (this.topPosition > 0) {
                        this.element.forEach((item) => (item.style.top = "0px"));
                    } else {
                        this.topPosition = this.topPosition - this.step;
                        this.element.forEach((item) => (item.style.top = this.topPosition + "px"));
                    }
                    // console.log(this.topPosition);
                    break;
                default:
                    break;
            }
        }
    };

    document.getElementsByClassName("price-item--regular")[0].addEventListener("click", function (event) {
        player.move("ArrowUp");
    });
    document.getElementsByClassName("slider-button-up")[0].addEventListener("click", function (event) {
        // console.log("top");
        player.move("ArrowUp");
    });
    document.getElementsByClassName("slider-button-bottom")[0].addEventListener("click", function (event) {
        // console.log("bottom");
        player.move("ArrowDown");
    });

    const detailproduct = {
        element: document.getElementsByClassName("thumbnail-slider-wrapper")[0],
        height: 0,
        init: function () {
            this.height = this.element.clientHeight;
            // console.log(this.element);
            // console.log(this.height);
            document.getElementsByClassName("thumbnail-list")[0].style.height = this.height + "px";
        }
    };
    detailproduct.init();
};
